export const ingredientsRoute = {
  INGREDIENT_MAIN: '/bahan-baku',
  INGREDIENT_LIST: '/bahan-baku/daftar',
  INGREDIENT_CATEGORY: '/bahan-baku/kategori',
  RECIPES: '/bahan-baku/resep',
  SUMMARY: '/bahan-baku/ringkasan',
}
